import axios from 'axios'

export default {
    namespaced: true,
    state: {
        childcareApplicationAttachments: [],
        childcareApplicationAttachment: {},
    },
    mutations: {
        SET_CHILDCARE_APPLICATION_ATTACHMENTS(state, payload) {
            state.childcareApplicationAttachments = payload;
        },
        SET_CHILDCARE_APPLICATION_ATTACHMENT(state, payload) {
            state.childcareApplicationAttachment = payload;
        },
    },
    actions: {
        async FetchChildcareApplicationAttachments({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/childcare/attachments/list`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_CHILDCARE_APPLICATION_ATTACHMENTS', response.data.payload);
                            resolve(response.data.message);
                        }
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchChildcareApplicationAttachments: ${error.message}`));
            });
        },
        async FetchChildcareApplicationAttachment({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/childcare/attachments/fetch`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_CHILDCARE_APPLICATION_ATTACHMENT', response.data.payload);
                            resolve(response.data.message);
                        }
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchChildcareApplicationAttachment: ${error.message}`));
            });
        },
        async InsertChildcareApplicationAttachment({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/childcare/attachments/insert`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`InsertChildcareApplicationAttachment: ${error.message}`));
            });
        },
        async DeleteChildcareApplicationAttachment({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/childcare/attachments/delete`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`DeleteChildcareApplicationAttachment: ${error.message}`));
            });
        },
    },
    getters: {
        ChildcareApplicationAttachments(state) { return state.childcareApplicationAttachments; },
        ChildcareApplicationAttachment(state) { return state.childcareApplicationAttachment; },
    }
}
